import { useTranslation } from 'react-i18next';
import { DialogTitle } from '@shared/typography/title';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { UserFormView } from '@app/feature/user/generic-user/user-form/user-form.view';
import { Snackbar } from '@shared/snackbar/snackbar';
import { useApiError } from '@app/core/helper/use-api-error';
import { useCreateAdminMutation } from '@service/admin.service';
import { UserFormModel } from '@model/user.model';

interface AdminCreateProps {
  onCancel: () => void;
  onSuccess: () => void;
  onError: () => void;
}

export function CreateAdmin({
  onCancel,
  onSuccess,
  onError,
}: AdminCreateProps): React.JSX.Element {
  const { t } = useTranslation();

  const [handleCreateAdmin, { isLoading, isError, error }] =
    useCreateAdminMutation();
  const { status, message } = useApiError(error);

  const handleSubmit = (payload: UserFormModel): void => {
    handleCreateAdmin(payload).unwrap().then(onSuccess).catch(onError);
  };

  return (
    <>
      <DialogTitle icon={<PersonAddIcon />}>
        {t('user.administrator.create.title')}
      </DialogTitle>

      <UserFormView
        formType="create"
        onSubmit={handleSubmit}
        pending={isLoading}
        onCancel={onCancel}
      />

      {isError && (
        <Snackbar
          variant="error"
          message={t('error.create-user-mutation', { status, message })}
        />
      )}
    </>
  );
}
